/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/label-has-associated-control, react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPages, removePage } from '../slice/pageSlice';
import { FaEdit, FaTrash, FaSearch, FaFileAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import ConfirmModal from '../common/ConfirmModal';
import './PageList.css';

const PageList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { data: pages = [], loading } = useSelector((state) => state.pages);
  
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);
  const [selectedPages, setSelectedPages] = useState([]);
  
  const handleEditPage = (page) => {
    if (page.id === 1 || (page.title && page.title.toLowerCase() === 'home')) {
      navigate(`/edit-home/${page.id}`);
    } else if (page.id === 2 || (page.title && page.title.toLowerCase().includes('about'))) {
      navigate(`/edit-about/${page.id}`);
    } else if (page.id === 5 || (page.title && page.title.toLowerCase().includes('faq'))) {
      navigate(`/edit-faq/${page.id}`);
    } else if (page.id === 9 || (page.title && page.title.toLowerCase().includes('privacy'))) {
      navigate(`/edit-privacy/${page.id}`);
    } else if (page.id === 12 || (page.title && page.title.toLowerCase().includes('train')) || (page.title && page.title.toLowerCase().includes('programm'))) {
      navigate(`/edit-training/${page.id}`);
    } else if (page.id === 13 || (page.title && page.title.toLowerCase().includes('partner'))) {
      navigate(`/edit-partner/${page.id}`);
    } else if (page.id === 14 || (page.title && page.title.toLowerCase().includes('store')) || (page.title && page.title.toLowerCase().includes('locat'))) {
      navigate(`/edit-store-locator/${page.id}`);
    } else {
      toast.info(`Edit layout for "${page.title}" coming soon!`);
    }
  };
  
  // Custom Confirmation Modal State
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);

  useEffect(() => {
    dispatch(getPages());
  }, [dispatch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedPages(pages.map(p => p.id));
    } else {
      setSelectedPages([]);
    }
  };

  const handleSelectOne = (id) => {
    if (selectedPages.includes(id)) {
      setSelectedPages(selectedPages.filter(item => item !== id));
    } else {
      setSelectedPages([...selectedPages, id]);
    }
  };

  const triggerDeleteConfirm = (e, page) => {
    e.preventDefault();
    e.stopPropagation();
    setDeleteTarget(page);
  };

  const confirmDelete = () => {
    if (deleteTarget) {
      dispatch(removePage(deleteTarget.id));
      toast.success('Page deleted successfully');
      setDeleteTarget(null);
    }
  };

  const handleConfirmEdit = () => {
    if (editTarget) {
      const page = editTarget;
      setEditTarget(null);
      handleEditPage(page);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, '0');
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  const filteredPages = pages.filter(page => 
    page.title && 
    !['blogs', 'events', 'home'].includes(page.title.toLowerCase()) &&
    page.id !== 1 &&
    page.title.toLowerCase() !== 'home' &&
    !page.title.toLowerCase().includes('terms') &&
    !page.title.toLowerCase().includes('advantage') &&
    page.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPages = filteredPages.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="premium-page-container animate-fade-up">
        {/* Header Section */}
        <div className="premium-page-header">
          <h1 className="page-title">Page Manager</h1>
        </div>

        {/* Search & Actions Panel */}
        <div className="premium-controls-bar">
          <div className="search-bar-wrapper search-box" style={{ margin: 0 }}>
            <FaSearch className="search-icon" />
            <input 
              type="text" 
              placeholder="Search page..." 
              value={searchQuery}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>
        </div>

        {/* Page Table Area */}
        <div className="premium-table-wrapper">
          {loading ? (
            <div className="loading-spinner" style={{ padding: '2rem', textAlign: 'center', color: '#c4a882' }}>Loading pages...</div>
          ) : filteredPages.length === 0 ? (
            <div className="empty-state" style={{ padding: '2rem', textAlign: 'center', color: '#c4a882' }}>No pages found.</div>
          ) : (
              <table className="premium-table">
                <thead>
                  <tr>
                    <th style={{ width: '4%' }}>
                      <input 
                        type="checkbox" 
                        className="premium-checkbox"
                        onChange={handleSelectAll} 
                        checked={selectedPages.length === pages.length && pages.length > 0}
                      />
                    </th>
                    <th style={{ width: '42%' }}>Page Title</th>
                    <th style={{ width: '22%' }}>Created on</th>
                    <th style={{ width: '22%' }}>Last Updated on</th>
                    <th style={{ width: '10%', textAlign: 'center' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                {currentPages.map((page) => (
                  <tr key={page.id} className={selectedPages.includes(page.id) ? 'selected-row' : ''}>
                    <td>
                      <input 
                        type="checkbox" 
                        className="premium-checkbox"
                        checked={selectedPages.includes(page.id)}
                        onChange={() => handleSelectOne(page.id)}
                      />
                    </td>
                    <td>
                      <div className="page-title-cell">
                        <FaFileAlt className="page-icon" style={{ color: '#c4a882', fontSize: '13px', flexShrink: 0 }} />
                        <span className="page-title-text" title={page.title}>{page.title}</span>
                      </div>
                    </td>
                    <td className="nowrap-cell">{formatDate(page.created_on)}</td>
                    <td className="nowrap-cell">{formatDate(page.updated_on)}</td>
                    <td style={{ textAlign: 'center' }}>
                      <div className="inline-actions-container" style={{ justifyContent: 'center' }}>
                        <button 
                          className="btn-inline-action edit-action" 
                          onClick={() => setEditTarget(page)}
                          title="Edit Page Structure"
                        >
                          <FaEdit size={13} />
                        </button>
                        {(page.id === 9 || (page.title && page.title.toLowerCase().includes('privacy'))) && (
                          <button 
                            className="btn-inline-action" 
                            onClick={() => navigate(`/modify-page-content/${page.id}`)}
                            title="Edit Privacy Content"
                            style={{ color: '#60a5fa' }}
                          >
                            <FaFileAlt size={13} />
                          </button>
                        )}
                        <button 
                          className="btn-inline-action delete-action" 
                          onClick={(e) => triggerDeleteConfirm(e, page)}
                          title="Delete Page"
                        >
                          <FaTrash size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Pagination Controls */}
          {filteredPages.length > 0 && (
            <div className="premium-pagination-container" style={{ margin: '1.5rem 0 0 0' }}>
              <div className="premium-pagination-info">
                Showing <span>{indexOfFirstItem + 1}</span> to <span>{Math.min(indexOfLastItem, filteredPages.length)}</span> of <span>{filteredPages.length}</span> entries
              </div>
              <div className="premium-pagination-list">
                <button 
                  className="premium-pagination-btn arrow-btn" 
                  onClick={() => setCurrentPage(1)} 
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button 
                  className="premium-pagination-btn arrow-btn" 
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                  disabled={currentPage === 1}
                >
                  &lsaquo;
                </button>
                
                {Array.from({ length: Math.ceil(filteredPages.length / itemsPerPage) }, (_, idx) => idx + 1)
                  .filter(page => {
                    const totalPages = Math.ceil(filteredPages.length / itemsPerPage);
                    return page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1;
                  })
                  .map((page, index, array) => {
                    return (
                      <React.Fragment key={page}>
                        {index > 0 && array[index - 1] !== page - 1 && (
                          <span style={{ color: 'rgba(196, 168, 130, 0.4)', padding: '0 0.25rem' }}>...</span>
                        )}
                        <button 
                          className={`premium-pagination-btn ${currentPage === page ? 'active' : ''}`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  })}

                <button 
                  className="premium-pagination-btn arrow-btn" 
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredPages.length / itemsPerPage)))} 
                  disabled={currentPage === Math.ceil(filteredPages.length / itemsPerPage)}
                >
                  &rsaquo;
                </button>
                <button 
                  className="premium-pagination-btn arrow-btn" 
                  onClick={() => setCurrentPage(Math.ceil(filteredPages.length / itemsPerPage))} 
                  disabled={currentPage === Math.ceil(filteredPages.length / itemsPerPage)}
                >
                  &raquo;
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Confirmation Modals */}
      <ConfirmModal
        isOpen={!!editTarget}
        type="edit"
        title="Modify Page"
        itemName={editTarget?.title}
        itemType="page"
        onConfirm={handleConfirmEdit}
        onCancel={() => setEditTarget(null)}
      />

      <ConfirmModal
        isOpen={!!deleteTarget}
        type="delete"
        title="Delete Page"
        itemName={deleteTarget?.title}
        itemType="page"
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </>
  );
};

export default PageList;
